import { SwipeableDrawer } from "@material-ui/core";
import { UISref } from "@uirouter/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { ReportIssueRoutes } from "../../pages/report-issue/routes";
import { AppStore } from "../../store";
import { AuthActions } from "../../store/auth/actions";
import { useIsImpersonation } from "../../store/auth/hooks";
import { SidebarActions } from "../../store/sidebar/actions";
import { colours } from "../../styles/colours";
import { Menu, MenuItem, MenuNode } from "../menu";
import { WhiteItem } from "../menu/item/white";
import { SidebarBasePropTypes } from "./base";
import { useRouteChange, useSidebarNodes } from "./hooks";

const ReportIssueMenuItem = styled(WhiteItem)`
  color: ${colours.red};
`;

const DeveloperItem = styled(WhiteItem)`
  margin-top: 1em;
  border-top: 1px solid ${colours.grey};
`;

export type MobileSidebarPropTypes = Omit<
  SidebarBasePropTypes,
  "immediateCollapsed" | "delatyedCollapsed" | "toggleCollapsed"
>;

export const MobileSidebar: React.FunctionComponent<MobileSidebarPropTypes> = (
  props
) => {
  const dispatch = useDispatch();
  const isOpen = useSelector<AppStore, boolean>(
    (store) => store.sidebar.isOpen
  );
  const { t } = useTranslation("common");
  const sidebarListWithSelection = useSidebarNodes();
  const isImpersonation = useIsImpersonation();
  useRouteChange();

  return (
    <SwipeableDrawer
      anchor="left"
      open={isOpen}
      onClose={() => dispatch(SidebarActions.closeSidebar())}
      onOpen={() => dispatch(SidebarActions.openSidebar())}
    >
      <Menu>
        {sidebarListWithSelection.map((node) => (
          <MenuItem
            node={node}
            key={t(
              MenuNode.isLeafNode(node)
                ? MenuNode.isLeafTargeted(node)
                  ? t(node.title)
                  : t(node.route.data.title)
                : node.title,
              { ns: "page-titles" }
            )}
            compact={false}
            routeOnOpen={false}
          />
        ))}
        <a
          href="https://sekuritance.readme.io/"
          target="_blank"
          rel="noreferrer"
        >
          <DeveloperItem icon="customers">{t("developers-api")}</DeveloperItem>
        </a>
        <a
          href="https://sekuritance.com/about-us/"
          target="_blank"
          rel="noreferrer"
        >
          <WhiteItem icon="aboutUs" variant="leaf">
            {t("about-us")}
          </WhiteItem>
        </a>
        <UISref to={ReportIssueRoutes.names.index}>
          <a>
            <ReportIssueMenuItem>{t("report-an-issue")}</ReportIssueMenuItem>
          </a>
        </UISref>
        {isImpersonation ? (
          <ReportIssueMenuItem
            onClick={() => dispatch(AuthActions.stopImpersonationRequest())}
          >
            <strong>{"stop-impersonation"}</strong>
          </ReportIssueMenuItem>
        ) : null}
        <WhiteItem icon="logout" onClick={() => dispatch(AuthActions.logout())}>
          {t("logout")}
        </WhiteItem>
      </Menu>
    </SwipeableDrawer>
  );
};
